import { OTPCheckDto, OTPCheckDtoImpl } from './otpcheckdto';
import { NoDataException } from '../../../../utils/exceptions/nodataexistsexception';

export class OTPCheckBuilder {
    constructor(private otpCheckResponse: any) {
        if(otpCheckResponse === undefined)
        {
            throw new NoDataException("Otp check data doesnt exists");
        }
    }

    buildAll(): OTPCheckDto {
        return this.parseOtpCheckResponse();
    }

    private parseOtpCheckResponse(): OTPCheckDto {
        let otpCheckResponseItem = this.otpCheckResponse;

        let otpCheckDto = null;
        otpCheckDto = new OTPCheckDtoImpl();
        otpCheckDto.setRespCode(otpCheckResponseItem.respCode);
        otpCheckDto.setRespDesc(otpCheckResponseItem.respDesc);
        otpCheckDto.setSrvType(otpCheckResponseItem.srvType);
        otpCheckDto.setUserId(otpCheckResponseItem.userId);
        otpCheckDto.setUserIdEnc(otpCheckResponseItem.userIdEnc);
        otpCheckDto.setUserName(otpCheckResponseItem.username);

        return otpCheckDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckbuilder.ts